import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { Col } from "react-bootstrap";

const Empty = ({ text, small }) => {
  return (
    <Col lg={12} className="mt-5 py-5 text-center">
      <FontAwesomeIcon icon={faClipboard} size={small ? "4x" : "9x"} color="rgba(15, 188, 73, 0.4)" />
      <div className="mt-2" style={{ color: "rgba(15, 188, 73, 0.9)", fontSize: small ? "14px" : "24px" }}>
        {text}
      </div>
    </Col>
  );
};

export default Empty;
